export default __webpack_public_path__ + "static/media/home-beta.24c71fe2.svg";